<template>
  <div :class="$store.state.logged ? 'app bg-t-dark-' : ''">
    <vue-progress-bar></vue-progress-bar>
    <SideBar class="t-side-bar" v-if="$store.state.logged" />
    <NavBarMobile v-if="$store.state.logged" class="nav-bar-mobile" />
    <UserCard class="user-card" v-if="$store.state.logged" />
    <div class="main-wrapper">
      <div :class="$store.state.logged ? 'container-fluid' : ''">
        <router-view />
      </div>
    </div>
    <div class="version-wrapper" v-if="$store.state.logged">
      v{{ this.version }}
    </div>
    <div class="version-wrapper-login" v-else>
      v{{ this.version }}
    </div>
  </div>
</template>

<script>
import SideBar from '@/components/base/SideBar'
import UserCard from '@/components/base/UserCard'
import NavBarMobile from '@/components/base/NavBarMobile'

export default {
  components: {
    SideBar,
    UserCard,
    NavBarMobile
  },
  data() {
    return {
      version: process.env.VUE_APP_VERSION
    }
  },
  mounted() {
    this.$Progress.finish()
    if (process.env.VUE_APP_ENV != 'production') {
      let pagebody = document.getElementsByTagName('body')[0]
      pagebody.style.borderTop = '4px solid orange'
    }
  }
}
</script>

<style lang="scss">
.nav-bar-mobile {
  display: none;
}

@media only screen and (max-width: 1000px) {
  .nav-bar-mobile {
    display: block;
  }

  .app {
    display: block !important;

    .main-wrapper {
      margin-top: 0px !important;
    }
  }
}

.app {
  display: flex;
  height: 100vh;

  @media only screen and (max-width: 1000px) {
    .t-side-bar {
      display: none;
    }

    .user-card {
      display: none;
    }
  }

  .t-side-bar {
    width: 250px;
  }

  .user-card {
    position: fixed;
    right: 8px;
    top: 20px;
  }

  .main-wrapper {
    margin-top: 105px;
    width: 100%;
    max-height: 100vh;
    overflow-y: auto;
  }
}

.version-wrapper {
  position: fixed;
  bottom: 8px;
  left: 8px;
  color: rgba(255, 255, 255, 0.767);
  font-size: 13px;
  text-shadow: 0 0 2px white;
  /* horizontal-offset vertical-offset 'blur' colour */
  -moz-text-shadow: 0 0 2px white;
  font-weight: bold;
  -webkit-text-shadow: 0 0 2px white;
}

.version-wrapper-login {
  position: fixed;
  width: 100%;
  bottom: 5px;
  text-align: center;
  color: black;
  // text-decoration: underline;
  font-size: 13px;
  text-shadow: 0 0 2px white;
  /* horizontal-offset vertical-offset 'blur' colour */
  -moz-text-shadow: 0 0 2px white;
  font-weight: bold;
  -webkit-text-shadow: 0 0 2px white;
}
</style>
